import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_stacktrace/product-planning-core/anchor-date/')({});